module.exports = __webpack_public_path__ + "img/icon_grid_down.6fcfb848.svg";